<template>
  <div class="vxxx">
    <div v-loading="isLoading" element-loading-background="rgba(255,255,255,0.97)">
      <div class="titleName">
        {{ $t('system.changePassword.account') }}
      </div>
      <div class="vxstep1" v-if="!step1Hide">
        <div class="item">
          <span class="label">{{ $t('system.changePassword.accountType') }}：</span>
          <span class="type">{{ accountType }}</span>
          <span class="btn" @click="changeAccountType">{{ $t('system.changePassword.change') }}</span>
        </div>
        <div class="item mt10" v-if="!pwdUpdated">
          <span class="label">{{ $t('system.changePassword.dftPwd') }}：</span>
          <span class="btn" @click="changePassword">{{ $t('system.changePassword.change') }}</span>
        </div>
      </div>
      <div class="vxstep2" v-if="!step2Hide">
        <div class="item">
          <el-form ref="userEmailFormRef" :rules="rules" :model="form" label-position="left" label-width="auto"
            style="width: 100%;">
            <el-form-item class="is-required" prop="email"
              :label="$t('system.password.pleaseEnter') + $t('user.email') + '：'">
              <el-input v-model="form.email" :placeholder="$t('system.password.pleaseEnter')" @input="emailBlur" />
            </el-form-item>
          </el-form>
        </div>
        <el-button @click="inputEmailNext" :disabled="disableEmailNext" type="primary">
          {{ $t('system.changePassword.btnNext') }}
        </el-button>
      </div>
      <div class="vxstep3" v-if="!step3Hide">
        <div class="item">
          <el-form ref="userEmailForm2Ref" :rules="rules" :model="form2" label-position="left" label-width="auto"
            style="width: 100%;">
            <el-form-item class="is-required" :label="$t('system.changePassword.accountType') + '：'">
              <el-radio-group v-model="form2.type">
                <el-radio label="1">
                  {{ $t('system.changePassword.accountEmail') }}
                </el-radio>
                <el-radio label="2">
                  {{ $t('system.changePassword.accountGeneral') }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form2.type == '1'" prop="email"
              :label="$t('system.password.pleaseEnter') + $t('user.email') + '：'">
              <el-input v-model="form2.email" :placeholder="$t('system.password.pleaseEnter')" @input="emailBlur2" />
            </el-form-item>
          </el-form>
        </div>
        <el-button @click="inputEmailNext2" :disabled="disableEmailNext2" type="primary">
          {{ $t('system.changePassword.btnNext') }}
        </el-button>
      </div>
    </div>
    <el-dialog v-model="showNewPassword" :title="dlgInfo.title" :width="300" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false" center>
      <p class="center">
        {{ $t('system.changePassword.tip1') }}：
        <span>{{ new_password }}</span>
      </p>
      <p class="center">
        请重新登录
      </p>
      <p class="center">
        <span class="btnCopy" @click="copyPwd">复制邀请信息</span>
      </p>
      <template #footer>
        <div class="dialog-footer">
          <el-button :type="disabledOK ? 'info' : 'primary'" :disabled="disabledOK" @click="btnOK">
            {{ $t('system.changePassword.btnOK') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="showEmailCode" :width="300" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="t-left">
        <span v-html="txtCountDown" />
        <span class="btnCopy" v-show="timeCount < 0" @click="btnReSendVerifyCode">[{{ $t('user.resend') }}]</span>
      </div>
      <p class="center">
        <el-input v-model="iptVerifyCode" @input="codeBlur" />
      </p>
      <template #footer>
        <div class="dialog-footer" style="text-align: center;">
          <el-button :type="disabledVerifyBtn ? 'info' : 'primary'" :disabled="disabledVerifyBtn"
            @click="btnVerifyCode">
            {{ $t('system.changePassword.btnComplete') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="showEmailCode2" :width="300" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="t-left">
        <span v-html="txtCountDown2" />
        <span class="btnCopy" v-show="timeCount < 0" @click="btnReSendVerifyCode2">[{{ $t('user.resend') }}]</span>
      </div>
      <p class="center">
        <el-input v-model="iptVerifyCode2" @input="codeBlur2" />
      </p>
      <template #footer>
        <div class="dialog-footer" style="text-align: center;">
          <el-button :type="disabledVerifyBtn2 ? 'info' : 'primary'" :disabled="disabledVerifyBtn2"
            @click="btnVerifyCode2">
            {{ $t('system.changePassword.btnConfirm') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog v-model="statee2e.show" :width="300" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="t-left">
        <span v-html="statee2e.txtCountDown" />
        <span class="btnCopy" v-show="statee2e.timeCount < 0" @click="methode2e.resend">[{{ $t('user.resend') }}]</span>
      </div>
      <p class="center">
        <el-input v-model="statee2e.code" @input="methode2e.codeBlur" />
      </p>
      <template #footer>
        <div class="dialog-footer" style="text-align: center;">
          <el-button :type="statee2e.btnEnable ? 'primary' : 'info'" :disabled="statee2e.btnEnable ? false : true"
            @click="methode2e.complete">
            {{ $t('system.changePassword.btnConfirm') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { useStore } from '@/store';
import { computed, reactive, ref, toRefs, unref } from 'vue';
import execCopy from '@/utils/copy';
import { ElForm, ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import { UserActionTypes } from '@/store/modules/user/action-types';
import { switchPwd, sendEmailCode, admin2email, verfiyEmailCode, email2email, email2admin } from '@/apis/user';
import i18n from '@/locales/index';
const _t = i18n.global.t;
export default {
  props: [],
  components: {},
  setup(props, context) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const userEmailFormRef = ref(ElForm);
    const userEmailForm2Ref = ref(ElForm);

    const isLoading = ref(true),
      showNewPassword = ref(false),
      showEmailCode = ref(false),
      showEmailCode2 = ref(false),
      disabledOK = ref(true),
      disableEmailNext = ref(true),
      //disableEmailNext2 = ref(true),
      disabledVerifyBtn = ref(true),
      disabledVerifyBtn2 = ref(true);
    const new_password = ref('');
    const new_account = ref(store.state.user.email == '' ? store.state.user.name : store.state.user.email);
    const iptVerifyCode = ref('');
    const iptVerifyCode2 = ref('');

    const step1Hide = ref(false);
    const step2Hide = ref(true);
    const step3Hide = ref(true);

    const dlgInfo = reactive({
      title: '',
      login: '',
      copy: ''
    });

    setTimeout(() => {
      isLoading.value = false;
    }, 1e3 * 1);

    const changeAccountType = () => {
      if (store.state.user.email != '') {
        isLoading.value = true;
        sendEmailCode(store.state.user.email)
          .then((res) => {
            if (res.code == 200) {
              dlgInfo.title = _t('system.changePassword.accountChangeOK');
              dlgInfo.login = _t('system.changePassword.tip5');
              dlgInfo.copy = _t('system.changePassword.tip3');
              showEmailCode2.value = true;
              timeCount.value = 30;
              fnCountDown2();
            } else {
              ElMessage({
                type: 'error',
                message: _t('global.error500')
              });
            }
          })
          .catch((e) => {
            ElMessage({
              type: 'error',
              message: _t('global.error500')
            });
          })
          .finally(() => {
            isLoading.value = false;
          });
      } else {
        step1Hide.value = true;
        step2Hide.value = false;
      }
    };
    const changePassword = () => {
      isLoading.value = true;
      switchPwd()
        .then((res) => {
          if (res.code == 200) {
            dlgInfo.title = _t('system.changePassword.pwdChangeOK');
            dlgInfo.login = _t('system.changePassword.tip2');
            dlgInfo.copy = _t('system.changePassword.tip3');
            new_password.value = res.data['password'];
            showNewPassword.value = true;
          } else {
            ElMessage({
              type: 'error',
              message: _t('global.error500')
            });
          }
        })
        .catch(() => {
          ElMessage({
            type: 'error',
            message: _t('global.error500')
          });
        })
        .finally(() => {
          isLoading.value = false;
        });
    };
    const copyPwd = () => {
      const cpy = _t('system.changePassword.copyInfo', { account: new_account.value, password: new_password.value });
      execCopy(cpy, 'copy')
        .then(() => {
          ElMessage({
            message: _t('system.changePassword.tip4'),
            type: 'success'
          });
          disabledOK.value = false;
        })
        .catch(() => {
          ElMessage({
            message: 'copy error',
            type: 'error'
          });
        });
    };
    const btnOK = () => {
      showNewPassword.value = false;
      // @ts-ignore
      store.dispatch(UserActionTypes.ACTION_LOGIN_OUT, '');
      router.push(`/login?redirect=${route.fullPath}`).catch((err) => {
        console.warn(err);
      });
    };
    const validateEmail = (rule, value, callback) => {
      if (value === '') callback(new Error(_t('user.emailRule1')));
      else if (!/^[a-zA-Z0-9\u4e00-\u9fa5\u00C0-\u024F](([_-]|\.)?[a-zA-Z0-9\u4e00-\u9fa5\u00C0-\u024F]+)+@[a-zA-Z0-9]+([_-]?[a-zA-Z0-9]+)?(\.[a-zA-Z0-9]+([_-]?[a-zA-Z0-9]+)?)+$/.test(value)) callback(new Error(_t('user.emailRule2')));
      else callback();
    };
    const state = reactive({
      rules: {
        email: [{ validator: validateEmail, trigger: 'blur', required: true }]
      },
      form: {
        email: ''
      },
      form2: {
        email: '',
        type: store.state.user.email != '' ? '1' : '2'
      }
    });

    const txtCountDown = ref('');
    const timeCount = ref(30);
    const fnCountDown = () => {
      if (timeCount.value < 0) {
        return;
      }
      txtCountDown.value = _t('system.changePassword.countDown', { times: `<span class="c-blue">${timeCount.value}s</span>` });
      timeCount.value = timeCount.value - 1;
      setTimeout(fnCountDown, 1e3);
    };

    const txtCountDown2 = ref('');
    const fnCountDown2 = () => {
      if (timeCount.value < 0) {
        return;
      }
      txtCountDown2.value = _t('system.changePassword.countDown2', { times: `<span class="c-blue">${timeCount.value}s</span>` });
      timeCount.value = timeCount.value - 1;
      setTimeout(fnCountDown2, 1e3);
    };

    const inputEmailNext = () => {
      unref(userEmailFormRef).validate((valid) => {
        if (!valid) {
          showEmailCode.value = false;
          return;
        }
        isLoading.value = true;
        new_account.value = state.form.email;
        sendEmailCode(state.form.email)
          .then((res) => {
            if (res.code == 200) {
              showEmailCode.value = true;
              timeCount.value = 30;
              fnCountDown();
            } else {
              ElMessage({
                type: 'error',
                message: _t('global.error500')
              });
            }
          })
          .catch((e) => {
            ElMessage({
              type: 'error',
              message: _t('global.error500')
            });
          })
          .finally(() => {
            isLoading.value = false;
          });
      });
    };

    const statee2e = reactive({
      show: false,
      code: '',
      txtCountDown: '',
      timeCount: 30,
      btnEnable: false,
      doing: false
    });
    const methode2e = {
      countDown: () => {
        if (statee2e.timeCount < 0) {
          return;
        }
        statee2e.txtCountDown = _t('system.changePassword.countDown', { times: `<span class="c-blue">${statee2e.timeCount}s</span>` });
        statee2e.timeCount = statee2e.timeCount - 1;
        setTimeout(() => {
          methode2e.countDown();
        }, 1e3);
      },
      showError: () => {
        ElMessage({
          type: 'error',
          message: _t('global.error500')
        });
      },
      resend: () => {
        if (statee2e.doing) return;
        statee2e.doing = true;
        sendEmailCode(state.form2.email)
          .then((res) => {
            if (res.code == 200) {
              statee2e.timeCount = 30;
              methode2e.countDown();
            } else {
              methode2e.showError();
            }
          })
          .catch((e) => {
            methode2e.showError();
          })
          .finally(() => {
            statee2e.doing = false;
          });
      },
      complete: () => {
        if (statee2e.doing) return;
        statee2e.doing = true;
        email2email(state.form2.email, statee2e.code.trim())
          .then((res) => {
            if (res.code == 200) {
              dlgInfo.title = _t('system.changePassword.accountChangeOK');
              dlgInfo.login = _t('system.changePassword.tip5');
              dlgInfo.copy = _t('system.changePassword.tip3');
              new_password.value = res.data['password'];
              new_account.value = state.form2.email;
              showNewPassword.value = true;
              statee2e.show = false;
            } else if (res.code == 40008) {
              ElMessage({
                type: 'error',
                message: _t('global.error40008')
              });
            } else {
              methode2e.showError();
            }
          })
          .catch(() => {
            methode2e.showError();
          })
          .finally(() => {
            statee2e.doing = false;
          });
      },
      codeBlur: () => {
        if (statee2e.code.trim().length > 0) {
          statee2e.btnEnable = true;
        } else {
          statee2e.btnEnable = false;
        }
      },
      send: () => {
        if (statee2e.doing) return;
        statee2e.doing = true;
        sendEmailCode(state.form2.email)
          .then((res) => {
            statee2e.show = true;
            statee2e.timeCount = 30;
            methode2e.countDown();
          })
          .catch(() => {
            methode2e.showError();
          })
          .finally(() => {
            statee2e.doing = false;
          });
      }
    };

    const statee2a = reactive({
      doing: false
    });
    const methode2a = {
      showErr: () => {
        ElMessage({
          type: 'error',
          message: _t('global.error500')
        });
      },
      send: () => {
        if (statee2a.doing) return;
        statee2a.doing = true;
        isLoading.value = true;
        email2admin()
          .then((res) => {
            if (res.code == 200) {
              dlgInfo.title = _t('system.changePassword.accountChangeOK');
              dlgInfo.login = _t('system.changePassword.tip5');
              dlgInfo.copy = _t('system.changePassword.tip3');
              new_password.value = res.data['password'];
              new_account.value = 'admin';
              showNewPassword.value = true;
            } else {
              methode2a.showErr();
            }
          })
          .catch(() => {
            methode2a.showErr();
          })
          .finally(() => {
            statee2a.doing = false;
            isLoading.value = false;
          });
      }
    };

    const inputEmailNext2 = () => {
      if (state.form2.type == '1') {
        // email 2 email
        unref(userEmailForm2Ref).validate((valid) => {
          if (!valid) return;
          methode2e.send();
        });
      } else if (state.form2.type == '2') {
        // email 2 admin
        methode2a.send();
      }
    };

    const emailBlur = () => {
      unref(userEmailFormRef).validate((valid) => {
        if (!valid) {
          disableEmailNext.value = true;
          return;
        }
        disableEmailNext.value = false;
      });
    };
    const email2IsValid = ref(false);
    const emailBlur2 = () => {
      if (state.form2.type == '2') {
        //disableEmailNext2.value = false;
        return;
      }
      unref(userEmailForm2Ref).validate((valid) => {
        if (!valid) {
          //disableEmailNext2.value = true;
          email2IsValid.value = false;
          return;
        }
        //disableEmailNext2.value = false;
        email2IsValid.value = true;
      });
    };

    const codeBlur = () => {
      if (iptVerifyCode.value.trim().length > 0) disabledVerifyBtn.value = false;
      else disabledVerifyBtn.value = true;
    };
    const codeBlur2 = () => {
      if (iptVerifyCode2.value.trim().length > 0) disabledVerifyBtn2.value = false;
      else disabledVerifyBtn2.value = true;
    };

    let isVerifycode = false;
    // 验证邮箱验证码
    // admin -> email
    const btnVerifyCode = () => {
      if (isVerifycode) return;
      isVerifycode = true;
      admin2email(state.form.email, iptVerifyCode.value.trim())
        .then((res) => {
          if (res.code == 200) {
            dlgInfo.title = _t('system.changePassword.accountChangeOK');
            dlgInfo.login = _t('system.changePassword.tip5');
            dlgInfo.copy = _t('system.changePassword.tip3');
            new_password.value = res.data['password'];
            showNewPassword.value = true;
            showEmailCode.value = false;
          } else if (res.code == 40008) {
            ElMessage({
              type: 'error',
              message: _t('global.error40008')
            });
          } else {
            ElMessage({
              type: 'error',
              message: _t('global.error500')
            });
          }
        })
        .catch((e) => {
          ElMessage({
            type: 'error',
            message: _t('global.error500')
          });
        })
        .finally(() => {
          isVerifycode = false;
        });
    };
    const btnVerifyCode2 = () => {
      if (isVerifycode) return;
      isVerifycode = true;

      verfiyEmailCode(store.state.user.email, iptVerifyCode2.value.trim())
        .then((res) => {
          if (res.code == 200) {
            step1Hide.value = true;
            step2Hide.value = true;
            step3Hide.value = false;
            showEmailCode2.value = false;
          } else if (res.code == 40008) {
            ElMessage({
              type: 'error',
              message: _t('global.error40008')
            });
          } else {
            ElMessage({
              type: 'error',
              message: _t('global.error500')
            });
          }
        })
        .catch((e) => {
          ElMessage({
            type: 'error',
            message: _t('global.error500')
          });
        })
        .finally(() => {
          isVerifycode = false;
        });
    };

    let isResend = false;
    // 重发验证码
    const btnReSendVerifyCode = () => {
      if (isResend) return;
      isResend = true;
      sendEmailCode(state.form.email)
        .then((res) => {
          if (res.code == 200) {
            showEmailCode.value = true;
            timeCount.value = 30;
            fnCountDown();
          } else {
            ElMessage({
              type: 'error',
              message: _t('global.error500')
            });
          }
        })
        .catch((e) => {
          ElMessage({
            type: 'error',
            message: _t('global.error500')
          });
        })
        .finally(() => {
          isResend = false;
        });
    };

    // 重发验证码2
    const btnReSendVerifyCode2 = () => {
      if (isResend) return;
      isResend = true;
      sendEmailCode(store.state.user.email)
        .then((res) => {
          if (res.code == 200) {
            timeCount.value = 30;
            fnCountDown2();
          } else {
            ElMessage({
              type: 'error',
              message: _t('global.error500')
            });
          }
        })
        .catch((e) => {
          ElMessage({
            type: 'error',
            message: _t('global.error500')
          });
        })
        .finally(() => {
          isResend = false;
        });
    };

    return {
      ...toRefs(state),
      statee2e,
      methode2e,
      isLoading,
      step1Hide,
      step2Hide,
      step3Hide,
      showNewPassword,
      showEmailCode,
      showEmailCode2,
      disabledOK,
      disableEmailNext,
      disableEmailNext2: computed(() => {
        if (state.form2.type == '2') return false;
        return email2IsValid.value ? false : true;
      }),
      disabledVerifyBtn,
      disabledVerifyBtn2,
      new_password,
      userEmailFormRef,
      userEmailForm2Ref,
      iptVerifyCode,
      iptVerifyCode2,
      pwdUpdated: computed(() => {
        return store.state.user.pwd_updated == 1;
      }),
      accountType: computed(() => {
        if (store.state.user.email != '') {
          return _t('system.changePassword.accountEmail');
        } else if (store.state.user.name != '') {
          return _t('system.changePassword.accountGeneral');
        }
        return '';
      }),
      changeAccountType,
      changePassword,
      copyPwd,
      btnOK,
      inputEmailNext,
      inputEmailNext2,
      emailBlur,
      emailBlur2,
      btnVerifyCode,
      btnVerifyCode2,
      btnReSendVerifyCode,
      btnReSendVerifyCode2,
      codeBlur,
      codeBlur2,
      txtCountDown,
      txtCountDown2,
      timeCount,
      dlgInfo
    };
  }
};
</script>

<style lang="css">
.c-blue {
  color: #4053ff;
}

.vxxx .el-dialog {
  min-width: 300px;
}

.vxxx .el-dialog__body {
  padding: 20px 30px 0px 20px;
}

.vxxx .el-dialog__footer {
  padding: 10px;
}
</style>

<style lang="scss" scoped>
.titleName {
  font-size: 18px;
  font-weight: bold;
  margin: 0 0 20px;
}

.mt10 {
  margin-top: 10px;
}

.center {
  text-align: center;
}

.t-left {
  text-align: left;
}

.item {
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 14px;

  span {
    display: inline-flex;

    &.label {
      width: 150px;
      justify-content: right;
      margin-right: 10px;
    }

    &.type {
      margin-right: 20px;
    }

    &.btn {
      color: #4053ff;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.btnCopy {
  color: #4053ff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
</style>
